export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (email: string): boolean => {
  const value = (email ?? "").trim();
  return EMAIL_REGEX.test(value);
};
